const fetch = require("node-fetch");
const OpOasisABI = require("../abi/oasis_matching_market");
const contracts = require("../common/contracts");
const BN = require("bn.js");

const specials = {};
specials["USDC"] = 6;
specials["USDT"] = 6;
specials["WBTC"] = 8;

const addPrefix = (asset) => {
  return `0xf47261b0000000000000000000000000${asset
    .substring(2)
    .toLowerCase()}`;
};

const getOrder = async (index, asset1, asset2) => {
  const makerAssetData = addPrefix(asset1);
  const takerAssetData = addPrefix(asset2);

  const response = await fetch(
    `https://api.0x.org/sra/v3/orders?makerAssetData=${makerAssetData}&takerAssetData=${takerAssetData}`
  );
  const orders = await response.json();
  return orders.records[index];
};

const getNotExpiringOrder = async (asset1, asset2) => {
  let order;
  let index = 0;
  let time = new Date().getTime() / 1000 + 60; //+ 1 min
  while (
    !order ||
    parseInt(order.order.expirationTimeSeconds) < time ||
    order.order.takerFee != "0"
  ) {
    order = await getOrder(index, asset1, asset2);
    index++;
  }
  return order;
};

const getOasisOrder = async (web3, asset1, asset2, amountNeeded) => {
  const oasisContract = new web3.eth.Contract(
    OpOasisABI,
    contracts.OASIS.OASIS_MATCHING_MARKET
  );
  let offerId;
  while (!offerId || new BN(offer["2"]).lt(new BN(amountNeeded))) {
    if (!offerId) {
      offerId = await oasisContract.methods.getBestOffer(asset2, asset1).call();
    } else {
      offerId = await oasisContract.methods.getWorseOffer(offerId).call();
    }
    if (!offerId) {
      return "NO OFFER";
    }

    offer = await oasisContract.methods.getOffer(offerId).call();
  }
  return offerId;
};

const to18Format = (asset, numberStr) => {
  const number = new BN(numberStr);
  const decimals = specials[asset] ? specials[asset] : 18;
  if (decimals) {
    return number.mul(new BN(10).pow(new BN(18 - decimals))).toString(10);
  }
  return number.toString(10);
};

const from18Format = (asset, numberStr) => {
  const number = new BN(numberStr);
  const decimals = specials[asset];
  if (decimals) {
    return number.div(new BN(10).pow(new BN(18)));
  }
  return number.toString(10);
};

const formatAmount = (asset, numberStr, decimals = 4) => {
  const decimalAssets = specials[asset] ? specials[asset] : 18;
  if (numberStr.length < decimalAssets) {
    return "0." + numberStr.padStart(decimalAssets, "0").substring(0, decimals);
  } else {
    const numberBigInt = new BN(numberStr);
    const decimalsBigInt = new BN(decimalAssets);
    const divisor = new BN(10).pow(decimalsBigInt);
    const beforeDecimal = numberBigInt.div(divisor).toString(10);
    const afterDecimal = numberBigInt.mod(divisor).toString(10);
    return beforeDecimal + "." + afterDecimal.substring(0, decimals);
  }
};

module.exports = {
  get0xOrder: getNotExpiringOrder,
  getOasisOrder: getOasisOrder,
  to18Format: to18Format,
  from18Format: from18Format,
  formatAmount: formatAmount,
};
